import React from "react";
import {
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaPinterestP,
  FaCcVisa,
  FaCcPaypal,
  FaApplePay,
} from "react-icons/fa";
import {
  Headphones,
  MessageCircle,
  Map,
  ShieldCheck,
} from "lucide-react";
import {
  SiTiktok,
  SiX,
  SiGooglepay,
  SiAppstore,
  SiGoogleplay,
  SiRazorpay,
} from "react-icons/si";

import {
  MdEmail,
  MdOutlineVerifiedUser,
  MdSecurity,
} from "react-icons/md";

import {
  BsStars,
  BsShieldCheck,
  BsCreditCard,
} from "react-icons/bs";

import {
  HiOutlineGlobeAlt,
} from "react-icons/hi";

const destinations = [
  "Pattaya",
  "Bangkok",
  "Phuket",
  "Krabi",
  "Chiang Mai",
  "View All Destinations",
];

const attractions = [
  "Things To Do",
  "Shows & Tickets",
  "Island Tours",
  "Cruises",
  "Adventure Activities",
  "View All Attractions",
];

const travelInfo = [
  "Travel Guide",
  "Thailand Visa",
  "Flights to Thailand",
  "Currency Guide",
  "Packing Tips",
  "FAQs",
];

const company = [
  "About GoSehari",
  "Our Team",
  "Careers",
  "Partnerships",
  "Blog",
  "Contact Us",
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-[#06142f] text-white">

      {/* ===================================================== */}
      {/* TOP SECTION */}
      {/* ===================================================== */}
      <div className="bg-gradient-to-r from-[#181c4b] via-[#1609af] to-[#181c4b]">
        <div className="container">
          {/* Top Promo Strip */}

          {/* Top promo strip */}
          <div className="grid gap-8 border-b border-white/10 py-8 md:grid-cols-3 md:gap-6 lg:gap-10">
            {/* Subscribe */}
            <div className="flex flex-col items-start">
              <div className="mb-3 flex items-start gap-2.5">
                <span className="mt-0.5 text-sky-300">
                  {/* <IconUser /> */}
                </span>
                <div>
                  <h3 className="text-[15px] font-semibold leading-tight">Get Exclusive Travel Deals!</h3>
                  <p className="mt-0.5 text-[12px] text-white/60">
                    Subscribe and get up to 15% OFF on your next booking.
                  </p>
                </div>
              </div>
              <form
                className="mt-1 flex w-full max-w-sm overflow-hidden rounded-md"
                onSubmit={(e) => e.preventDefault()}
              >
                <input
                  type="email"
                  placeholder="Enter your email address"
                  className="min-w-0 flex-1 border-0 bg-white px-3.5 py-2.5 text-[13px] text-slate-800 outline-none placeholder:text-slate-400"
                />
                <button
                  type="submit"
                  className="shrink-0 bg-[#2563eb] px-5 py-2.5 text-[13px] font-semibold text-white transition hover:bg-blue-600"
                >
                  Subscribe
                </button>
              </form>
            </div>

            {/* App download */}
            <div className="flex flex-col items-start md:items-center">
              <div className="mb-3 flex items-start gap-2.5 md:max-w-xs">
                <span className="mt-0.5 text-sky-300">
                  {/* <IconPhone /> */}
                </span>
                <div>
                  <h3 className="text-[15px] font-semibold leading-tight">The GoSehari App Is Coming Soon</h3>
                  <p className="mt-0.5 text-[12px] text-white/60">
                    Your trips, bookings & travel plans — all in one place. Stay tuned!
                  </p>
                </div>
              </div>
              <div className="mt-1 flex flex-wrap gap-2.5">
                <a href="#" className="inline-flex items-center gap-2 rounded-md bg-black px-3 py-1.5 ring-1 ring-white/20 transition hover:ring-white/40">
                  <svg viewBox="0 0 24 24" className="h-5 w-5">
                    <path fill="#ea4335" d="M3.6 2.2l10.3 10.3-2.4 2.4L1.8 5.2c-.3-.5-.2-1.2.3-1.6l1.5-1.4z" />
                    <path fill="#fbbc04" d="M17.5 14.7l-3.6-2.1-2.5 2.5 4.6 4.6c.6.6 1.5.6 2.1 0l1.4-1.4c.5-.5.6-1.3.2-1.9l-2.2-1.7z" />
                    <path fill="#4285f4" d="M21.5 10.8L17.5 8.5l-3.7 3.7 3.7 3.7 4-2.3c.7-.4.7-1.4 0-1.8z" />
                    <path fill="#34a853" d="M3.6 21.8l8-8 2.4 2.4-8.5 4.9c-.7.4-1.5-.1-1.5-.9v-1.1c0-.5.2-1 .6-1.3z" />
                  </svg>
                  <div className="text-left leading-none">
                    <div className="text-[8px] uppercase tracking-wide text-white/70">GET IT ON</div>
                    <div className="text-[13px] font-semibold">Google Play</div>
                  </div>
                </a>
                <a href="#" className="inline-flex items-center gap-2 rounded-md bg-black px-3 py-1.5 ring-1 ring-white/20 transition hover:ring-white/40">
                  <svg viewBox="0 0 24 24" className="h-5 w-5 fill-white">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                  </svg>
                  <div className="text-left leading-none">
                    <div className="text-[8px] text-white/70">Download on the</div>
                    <div className="text-[13px] font-semibold">App Store</div>
                  </div>
                </a>
              </div>
            </div>

            {/* Pay later */}
            <div className="flex flex-col items-start md:items-end">
              {/* Header */}
              <div className="flex items-start gap-4 max-w-sm">
                {/* Icon */}
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-violet-600">
                  <Headphones className="h-6 w-6 text-white" />
                </div>

                {/* Text */}
                <div>
                  <h3 className="text-lg font-semibold text-white">
                    Need Help Planning?
                  </h3>

                  <p className="mt-1 text-sm leading-5 text-white/70">
                    Our travel experts are here to help you plan the perfect trip.
                  </p>
                </div>
              </div>

              {/* Buttons */}
              <div className="mt-3 flex w-full max-w-sm gap-3">
                <button className="flex h-12 flex-1 items-center justify-center gap-2 rounded-xl bg-[#25D366] font-semibold text-white transition hover:bg-[#1ebe5d]">
                  <MessageCircle className="h-5 w-5" />
                  WhatsApp Us
                </button>

                <button className="flex h-12 flex-1 items-center justify-center gap-2 rounded-xl bg-white font-semibold text-violet-700 transition hover:bg-gray-100">
                  <Map className="h-5 w-5" />
                  Plan My Trip
                </button>
              </div>

              {/* Footer */}
              <div className="mt-3 flex w-full max-w-sm items-center justify-center gap-2 text-xs text-white/70">
                <ShieldCheck className="h-4 w-4 text-green-400" />
                <span>Quick replies • Expert support • 100% Free</span>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* Section TWO  */}


      <div
        className="relative overflow-hidden bg-[#07152e]"
        style={{
          backgroundImage: "url('/footer-bg.png')",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right bottom",
          backgroundSize: "contain", // or "80%"
        }}
      >
        <div className="container">

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-10 py-12">
            <div className="lg:col-span-2">
              <h2 className="text-4xl font-extrabold tracking-tight">
                Go<span className="text-orange-400">Sehari</span>
              </h2>
              <p className="mt-3 text-sm leading-7 text-slate-300">
                Your trusted travel partner for unforgettable experiences in
                Thailand and beyond.
              </p>

              <div className="mt-8 space-y-4">
                <div className="flex items-center gap-3">
                  <BsStars className="text-orange-400" />
                  <span className="text-sm">
                    Best Price Guarantee
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <BsShieldCheck className="text-green-400" />
                  <span className="text-sm">
                    Secure & Safe Booking
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <MdOutlineVerifiedUser className="text-blue-400" />
                  <span className="text-sm">
                    Instant Confirmation
                  </span>
                </div>

                <div className="flex items-center gap-3">

                  <MdSecurity className="text-cyan-400" />

                  <span className="text-sm">
                    24/7 Customer Support
                  </span>

                </div>

              </div>

            </div>

            {/* Destinations */}

            <div>

              <h4 className="font-bold mb-5">
                Top Destinations
              </h4>

              <ul className="space-y-3">

                {destinations.map((item) => (

                  <li
                    key={item}
                    className="text-sm text-slate-300 hover:text-white cursor-pointer transition"
                  >
                    {item}
                  </li>

                ))}

              </ul>

            </div>

            {/* Attractions */}

            <div>

              <h4 className="font-bold mb-5">
                Top Attractions
              </h4>

              <ul className="space-y-3">

                {attractions.map((item) => (

                  <li
                    key={item}
                    className="text-sm text-slate-300 hover:text-white cursor-pointer transition"
                  >
                    {item}
                  </li>

                ))}

              </ul>

            </div>

            {/* Travel */}

            <div>

              <h4 className="font-bold mb-5">
                Travel Info
              </h4>

              <ul className="space-y-3">

                {travelInfo.map((item) => (

                  <li
                    key={item}
                    className="text-sm text-slate-300 hover:text-white cursor-pointer transition"
                  >
                    {item}
                  </li>

                ))}

              </ul>

            </div>

            {/* Company */}

            <div>

              <h4 className="font-bold mb-5">
                Company
              </h4>

              <ul className="space-y-3">

                {company.map((item) => (

                  <li
                    key={item}
                    className="text-sm text-slate-300 hover:text-white cursor-pointer transition"
                  >
                    {item}
                  </li>

                ))}

              </ul>

            </div>

          </div>

          {/* ========================================= */}
          {/* SOCIAL & PAYMENT */}
          {/* ========================================= */}

          <div className="border-t border-white/10 py-4">

            <div className="flex flex-col lg:flex-row justify-between gap-10">

              {/* Social */}

              <div>

                <h4 className="font-semibold mb-3">
                  Follow Us
                </h4>

                <div className="flex flex-wrap gap-3">

                  {[
                    <FaInstagram />,
                    <FaFacebookF />,
                    <FaYoutube />,
                    <SiTiktok />,
                    <SiX />,
                    <FaPinterestP />,
                  ].map((icon, i) => (

                    <div
                      key={i}
                      className="w-11 h-11 rounded-full bg-white/10 hover:bg-blue-600 transition duration-300 flex items-center justify-center cursor-pointer text-lg"
                    >
                      {icon}
                    </div>

                  ))}

                </div>

              </div>

              {/* Payment */}

              <div>

                <h4 className="font-semibold mb-3">
                  We Accept
                </h4>

                <div className="flex flex-wrap gap-3">

                  <div className="rounded-lg w-30 h-12 flex items-center justify-center">
                    <img
                      src="/icons/visa.png"
                      alt="Visa"
                      className="h-10 object-contain"
                    />
                  </div>

                  <div className="rounded-lg w-30 h-12 flex items-center justify-center">
                    <img
                      src="/icons/mastercard.png"
                      alt="MasterCard"
                      className="h-10 object-contain"
                    />
                  </div>

                  <div className="rounded-lg w-30 h-12 flex items-center justify-center">
                    <img
                      src="/icons/amex.png"
                      alt="American Express"
                      className="h-10 object-contain"
                    />
                  </div>

                  <div className="ounded-lg w-30 h-12 flex items-center justify-center">
                    <img
                      src="/icons/paypal.png"
                      alt="PayPal"
                      className="h-10 object-contain"
                    />
                  </div>



                  <div className="rounded-lg w-30 h-12 flex items-center justify-center">
                    <img
                      src="/icons/upi.png"
                      alt="UPI"
                      className="h-10 object-contain"
                    />
                  </div>

                </div>

              </div>

            </div>

          </div>


          {/* ========================================= */}
          {/* BOTTOM BAR */}
          {/* ========================================= */}

          <div className="border-t border-white/10 py-4">

            <div className="flex flex-col lg:flex-row items-center justify-between gap-6">

              <div className="flex flex-wrap justify-center gap-8 text-sm text-slate-400">

                <a
                  href="#"
                  className="hover:text-white transition"
                >
                  Privacy Policy
                </a>

                <a
                  href="#"
                  className="hover:text-white transition"
                >
                  Terms & Conditions
                </a>

                <a
                  href="#"
                  className="hover:text-white transition"
                >
                  Refund Policy
                </a>

              </div>

              <p className="text-center text-sm text-white">
                © 2026 GoSehari Travel. All Rights Reserved.
              </p>

            </div>


            <svg
              className="absolute bottom-0 left-0 w-full opacity-20"
              viewBox="0 0 1440 250"
              preserveAspectRatio="none"
            >
              <path
                fill="#2f7cf6"
                fillOpacity="0.4"
                d="M0,160 C220,210 320,80 560,130 C760,170 980,250 1440,140 L1440,250 L0,250 Z"
              />

              <path
                fill="#5ca9ff"
                fillOpacity="0.3"
                d="M0,180 C240,120 450,250 700,180 C980,120 1120,40 1440,180 L1440,250 L0,250 Z"
              />
            </svg>


          </div>
        </div>
      </div>

    </footer>
  );
}

